export enum EPolicyType {
  QUOTING = "QUOTING",
  SERVICE = "SERVICE",
}
